import InterestToggle from './InterestToggle.component';

export default InterestToggle;